import { ReactComponent as EmptyBox } from 'assets/svg/EmptyBox.svg'
import { ReactComponent as Plus16 } from 'assets/svg/Plus16.svg'
import Typography from '../../../../components/Typography/Typography'
import { Button, BUTTON_TYPES } from '../../../../components/Button'
import { BTN_TXT } from '../../../../constants'
import './styles.scss'
import { routes } from '../../../../router'
import useRouter from '../../../../hooks/useRouter'
import { VENDORS_TABS_OPTIONS_KEYS } from '../constants'
import { MY_COMMUNITY_KEYS } from '../../constants'
import { ACTIONS, Can, SUBJECTS, ability } from 'features/Permission'
import { useMemo } from 'react'

export const EmptyState = () => {
  const { navigate } = useRouter()
  const createVendor = () => navigate(`${routes.myCommunity}/vendor-creation`)
  const addVendors = () =>
    navigate(
      `${routes.myCommunity}/${MY_COMMUNITY_KEYS.vendors}/${VENDORS_TABS_OPTIONS_KEYS.vendors_repository}`
    )

  const canAddToMyVendors = ability.can(ACTIONS.ADD, SUBJECTS.MY_VENDORS)
  const canCreateVendors = ability.can(ACTIONS.CREATE, SUBJECTS.VENDORS)

  const description = useMemo(() => {
    if (canAddToMyVendors) {
      return `To get started, add vendors from the repository
          or create a new one.`
    } else if (canCreateVendors) {
      return `To get started, create a new vendor.`
    } else {
      return `You do not have permission to add vendors.
          Please contact your sourcing leader to manage
          the vendor list.`
    }
  }, [canAddToMyVendors, canCreateVendors])

  return (
    <div className="my-vendors-container__empty-state row justify-center mt-32">
      <div className="my-vendors-container__empty-state__wrapper column align-center">
        <EmptyBox />
        <Typography.Headline6 className="mt-32">
          Your vendor list is empty
        </Typography.Headline6>
        <Typography.Paragraph className="mt-8">
          {description}
        </Typography.Paragraph>
        <div className="row gap-24 mt-16">
          <Can I={ACTIONS.ADD} a={SUBJECTS.MY_VENDORS}>
            <Button
              className=" mt-24"
              onClick={addVendors}
              icon={<Plus16 />}
              type={BUTTON_TYPES.DEFAULT}
              upperCase
              medium
            >
              {BTN_TXT.ADD_FROM_REPOSITORY}
            </Button>
          </Can>
          <Can I={ACTIONS.CREATE} a={SUBJECTS.VENDORS}>
            <Button
              className=" mt-24"
              onClick={createVendor}
              icon={<Plus16 />}
              type={BUTTON_TYPES.PRIMARY}
              upperCase
              medium
            >
              {BTN_TXT.CREATE_VENDOR}
            </Button>
          </Can>
        </div>
      </div>
    </div>
  )
}
